import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 55;
  .popup-container-background {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .delete-exercise-popup-container {
    width: 40%;
    height: 40vh;
    top: 30vh;
    background: white;
    border-radius: 25px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    .delete-exercise-popup-buttons-container {
      width: 50%;
      &.onlyButton {
        justify-content: center;
      }
    }
    .lf-player-container {
      height: 50%;
      max-height: 250px;
      width: auto;
      #lottie {
        height: 100%;
        max-height: 250px;
        svg {
          max-height: 100px;
        }
      }
    }
    &.loader {
      justify-content: center;
    }
  }
  iframe {
    border: none;
  }
  @media screen and (max-width: 867px) {
    .delete-exercise-popup-container {
      width: 90%;
      margin: 0 auto;
      top: 20vh;
      height: fit-content;
      padding: 4rem 0;
      .delete-exercise-popup-buttons-container {
        width: 90%;
        margin: 1rem auto 0;
        a {
          width: 40%;
        }
      }
    }
  }
`;
